"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _createStorage = _interopRequireDefault(require("./createStorage"));

var _usePersistedState = _interopRequireDefault(require("./usePersistedState"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* istanbul ignore file */
// tslint:disable
// there is a bug with strict-type-predicates and having strictNullChecks enaled


var createPersistedState = function createPersistedState(key, provider) {
  if (provider === void 0) {
    provider = typeof window !== 'undefined' ? window.localStorage : null;
  }

  if (provider) {
    var storage_1 = (0, _createStorage["default"])(provider);
    var namespace_1 = "@lce/local/" + key;
    return function (initialState) {
      return (0, _usePersistedState["default"])(initialState, namespace_1, storage_1);
    };
  }

  return _react.useState;
};

var _default = createPersistedState;
exports["default"] = _default;